export const AGE_OPTIONS = [
  {
    value: "30",
    labelKey: "board.connections.dialog.newTaskAgeLimit.lessThan1Month",
  },
  {
    value: "90",
    labelKey: "board.connections.dialog.newTaskAgeLimit.lessThan3Months",
  },
  {
    value: "180",
    labelKey: "board.connections.dialog.newTaskAgeLimit.lessThan6Months",
  },
  { value: "0", labelKey: "board.connections.dialog.newTaskAgeLimit.anyAge" },
] as const;

export interface AgeLimitSelection {
  selectedId?: string;
  labelKey?: string;
}

// NewTaskDaysLimit "-1" is the backend sentinel for "no age limit has been
// chosen yet" (see GmailSourceService/MailSourceService SetDefaultsAsync).
// It must never be reported as if one of AGE_OPTIONS were selected.
export function resolveAgeLimitSelection(
  newTaskDaysLimit: string | undefined,
): AgeLimitSelection {
  const matched = AGE_OPTIONS.find(
    (option) => option.value === newTaskDaysLimit,
  );
  return matched
    ? { selectedId: matched.value, labelKey: matched.labelKey }
    : {};
}
